const PermissionRoles = {
  AMC_DEVELOPER: 'amc_developer',
  ASSIGN_CAMPAIGN_TO_USER: 'assign_campaign_to_user',
  RTB_FLOOR_CAMPAIGN_SETTINGS: 'rtb_floor_campaign_settings',
  SYSTEM_CAMPAIGN_SETTINGS: 'system_campaign_settings'
};

export default PermissionRoles;



// WEBPACK FOOTER //
// ./src/views/StaticData/Roles/Permission.tsx